export function initBeverageNav(root, media = window.matchMedia('(max-width: 749px)')) {
  if (root.dataset.bvReady) return;
  root.dataset.bvReady = 'true';
  const levels = [...root.querySelectorAll('[data-bv-level]')];
  const back = root.querySelector('[data-bv-back]');
  const reset = () => {
    root.querySelectorAll('[data-bv-branch]').forEach(branch => { branch.hidden = false; });
    levels.forEach(level => { delete level.dataset.bvAncestor; });
  };
  const path = () => {
    const opened = [];
    let list = root.querySelector('.bv-roots');
    while (list) {
      const current = [...list.children].map(li => li.querySelector(':scope > details')).find(d => d?.open);
      if (!current) break;
      opened.push(current);
      list = current.querySelector(':scope > .bv-panel > ul');
    }
    return opened;
  };
  const refresh = () => {
    reset();
    const opened = path();
    root.toggleAttribute('data-bv-open', opened.length > 0);
    const backLabel = back.querySelector('[data-bv-back-label]');
    if (backLabel) {
      const parentTitle = opened.length > 1 ? opened[opened.length - 2].querySelector(':scope > summary').textContent.trim() : root.dataset.bvHomeLabel;
      backLabel.textContent = (root.dataset.bvBackPattern || 'Back to __TITLE__').replace('__TITLE__', parentTitle || 'Drinks');
    }
    back.hidden = !media.matches || opened.length === 0;
    if (!media.matches) {
      levels.filter(level => level.closest('.bv-groups')).forEach(level => { level.open = true; });
      return;
    }
    opened.forEach((level, index) => {
      const branch = level.parentElement;
      [...branch.parentElement.children].forEach(sibling => { sibling.hidden = sibling !== branch; });
      if (index < opened.length - 1) level.dataset.bvAncestor = 'true';
    });
  };
  const closeLast = () => {
    const opened = path();
    const last = media.matches ? opened[opened.length - 1] : opened[0];
    if (!last) return;
    last.open = false;
    refresh();
    last.querySelector(':scope > summary').focus();
  };
  const onToggle = event => {
    const level = event.target;
    if (!levels.includes(level)) return;
    if (level.open && (media.matches || !level.closest('.bv-groups'))) {
      const siblings = level.parentElement.parentElement.children;
      [...siblings].forEach(branch => {
        const other = branch.querySelector(':scope > details');
        if (other && other !== level) {
          other.open = false;
          other.querySelectorAll('details').forEach(nested => { nested.open = false; });
        }
      });
    } else if (!level.open) {
      level.querySelectorAll('details').forEach(nested => { nested.open = false; });
    }
    refresh();
  };
  root.addEventListener('toggle', onToggle, true);
  back.addEventListener('click', closeLast);
  root.addEventListener('keydown', event => {
    if (event.key === 'Escape' && path().length) {
      event.preventDefault();
      event.stopPropagation();
      closeLast();
    }
  });
  const onResize = () => {
    const focused = document.activeElement;
    const focusedRoot = focused === back ? path()[0] : levels.find(level => !level.closest('.bv-groups') && level.contains(focused));
    levels.forEach(level => { level.open = false; });
    refresh();
    if (focusedRoot) focusedRoot.querySelector(':scope > summary').focus();
  };
  media.addEventListener('change', onResize);
  if (media.matches) levels.forEach(level => { level.open = false; });
  refresh();
}

if (!customElements.get('qortex-beverage-nav')) {
  customElements.define('qortex-beverage-nav', class extends HTMLElement {
    connectedCallback() { initBeverageNav(this); }
  });
}
